// extracted by mini-css-extract-plugin
export default {"button":"carousel-buttons_button__eF9Cg"};